import { MONTHS } from '@constants/calendar';
import type { WeddingDateData } from '../../../utils/weddingDate';

export const formatWeddingDateForApi = (
	weddingDate: WeddingDateData,
): string | undefined => {
	if (weddingDate.dateOption === 'specificDate' && weddingDate.specificDate) {
		return weddingDate.specificDate;
	}
	if (
		weddingDate.dateOption === 'monthYear' &&
		weddingDate.month &&
		weddingDate.year
	) {
		const monthIndex = MONTHS.indexOf(weddingDate.month);
		if (monthIndex === -1) return undefined;
		const mm = String(monthIndex + 1).padStart(2, '0');
		return `${weddingDate.year}-${mm}-01`;
	}
	return undefined;
};

export const formatWeddingDateForMessage = (
	weddingDate: WeddingDateData,
): string | undefined => {
	if (weddingDate.dateOption === 'specificDate' && weddingDate.specificDate) {
		const match = weddingDate.specificDate.match(/^(\d{4})-(\d{2})-(\d{2})/);
		if (match) {
			const monthIndex = Number(match[2]) - 1;
			if (monthIndex < 0 || monthIndex >= MONTHS.length) return undefined;
			const day = Number(match[3]);
			return `${MONTHS[monthIndex]} ${day}, ${match[1]}`;
		}
	}
	if (
		weddingDate.dateOption === 'monthYear' &&
		weddingDate.month &&
		weddingDate.year
	) {
		return `${weddingDate.month} ${weddingDate.year}`;
	}
	return undefined;
};
